module.exports = __webpack_public_path__ + "static/media/enter.e32e104b.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/enter.glb
// module id = 90
// module chunks = 0